import { ReactNode, useId } from 'react';
import { useTranslation } from 'react-i18next';

import { locator } from '../../testing/e2e-locator/locator';
import { Button } from '../Button/Button';
import { Dialog } from '../Dialog/Dialog';
import { CloseRoundedIcon } from '../Icons/CloseRoundedIcon';

export const ApplicationQueuedLearnModal = ({
  onClose,
}: {
  onClose: () => void;
}): ReactNode => {
  const { t } = useTranslation();
  const titleId = useId();

  return (
    <Dialog
      labelledBy={titleId}
      testId={locator.components.applicationQueuedLearnModal.root}
      onClose={onClose}
    >
      <header
        data-testid={locator.components.applicationQueuedLearnModal.header.root}
      >
        <h1
          data-testid={locator.components.applicationQueuedLearnModal.header.h1}
          id={titleId}
        >
          {t('applicationQueuedLearnModal.title')}
        </h1>
        <button
          aria-label="Close learn more"
          data-testid={
            locator.components.applicationQueuedLearnModal.header.closeButton
          }
          type="button"
          onClick={onClose}
        >
          <CloseRoundedIcon />
        </button>
      </header>
      <div>
        <main
          data-testid={locator.components.applicationQueuedLearnModal.main.root}
        >
          <p
            data-testid={locator.components.applicationQueuedLearnModal.main.p}
          >
            {t('applicationQueuedLearnModal.content')}
          </p>
        </main>
        <footer
          data-testid={
            locator.components.applicationQueuedLearnModal.footer.root
          }
        >
          <Button
            data-testid={
              locator.components.applicationQueuedLearnModal.footer.closeButton
            }
            style={{ alignSelf: 'right' }}
            onClick={onClose}
          >
            {t('applicationQueuedLearnModal.close')}
          </Button>
        </footer>
      </div>
    </Dialog>
  );
};
